import * as types from '../constants/actionTypes';

export function updateOption(option, value) {
  return {
    type: types.UPDATE_OPTION,
    option,
    value
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/optionsActions.js
 **/